<!--
 * @Description: 線上測試 — 免費趣味測試（數據與首頁 mental-test 一致）
-->
<template>
	<section class="free-fun-test-section">
		<h2 class="free-fun-test-section__title">{{ title }}</h2>
		<ul class="free-fun-test-section__grid">
			<FunTestCard
				v-for="item in displayList"
				:key="item.key"
				:cover="item.cover"
				:title="item.title"
				@click="handleItem(item)"
			/>
		</ul>
	</section>
</template>

<script setup>
import { computed } from "vue";
import { goLink } from "~/utils/common";
import { getMentalList } from "~/api/api";
import FunTestCard from "./fun-test-card.vue";

const REN_SHENG_K_X_COVER =
	"https://img-fe.seersecret.com/image/a35475c2e83d5900be616dc8af0341a8-512x512.png";

defineProps({
	title: {
		type: String,
		default: "免費趣味測試",
	},
});

const { data: mentalData } = await useLazyAsyncData(
	"onlinecs-free-fun-test",
	async () => {
		try {
			const res = await getMentalList();
			return res.data;
		} catch (error) {
			console.error("加载趣味測試列表失败:", error);
			return [];
		}
	},
	{
		default: () => [],
	}
);

const displayList = computed(() => {
	const head = [
		{
			key: "static-ren-sheng-kx",
			title: "人生K線",
			cover: REN_SHENG_K_X_COVER,
			kind: "path",
			path: "/seer/bazi008",
		},
	];
	const tail = (mentalData.value || []).map(item => ({
		key: `api-${item.id}`,
		title: item.title,
		cover: item.cover,
		kind: "game",
		sort: item.sort,
	}));
	return [...head, ...tail];
});

function handleItem(item) {
	if (item.kind === "path" && item.path) {
		return goLink(item.path);
	}
	if (item.kind === "game" && item.sort != null) {
		logEvent("home_Free_click");
		return goLink(`/dist/game/play?id=${item.sort}`);
	}
}
</script>

<style lang="scss" scoped>
.free-fun-test-section {
	width: 1008px;
	margin: 40px auto 0;
	padding: 0;
	display: flex;
	flex-direction: column;
	font-family: PingFang SC;

	.free-fun-test-section__title {
		margin: 0 0 24px;
		font-weight: 500;
		font-size: 20px;
		color: #333333;
		line-height: 28px;
	}

	.free-fun-test-section__grid {
		margin: 0;
		padding: 0;
		list-style: none;
		display: grid;
		grid-template-columns: repeat(6, minmax(0, 1fr));
		gap: 12px;
	}
}
</style>
